<template>
  <div class="bottom-right-table-1">
    <dv-border-box-6>
      <div class="table-name" style="padding-top: 8px">
        <img src="./img/icon7.png" />料站信息
      </div>

      <dv-scroll-board style="margin-top: -10px" :config="config" />
    </dv-border-box-6>
  </div>
</template>

<script>
export default {
  name: 'BottomRightTable1',
  data () {
    return {
      config: {
        header: ['插槽', '元件', '方式', '上料状态', '首检状态', '替代料'],
        data: [],
        index: false,
        columnWidth: [120, 160, 80, 120, 120, 180],
        align: ['center'],
        rowNum: 13,
        headerHeight: 35,
        headerBGC: 'rgba(9, 37, 50, 0.4)',
        oddRowBGC: 'rgba(9, 37, 50, 0.4)',
        evenRowBGC: 'rgba(10, 32, 50, 0.3)',
        waitTime: 1200
      },
      lineId: undefined
    }
  },
  beforeMount(){
    const href = window.location.href
    const str = href.substr(href.indexOf("?")+1,href.length)
    const params = str.split('&')
    const code = params[0].split('=')[1]
    if (code){
      this.lineId = code;
    }
  },
  mounted () {
    const { getBigScreen } = this;
    getBigScreen();
    setInterval(getBigScreen, 30000);
  },
  methods: {
    async getBigScreen() {
      const data = await this.$http.post('https://apismt.moxitech.cn/admin-api/bigScreen/getWorkOrderStationDetail',{
        lineId: this.lineId
      }).then(res=>{
        return res.data.data
      }).catch(e=>{
        console.log(e)
      });
      this.config.data = data.map((item) => [item.slotName + "" + (item.subSlotName ? "-" +  item.subSlotName : ""), item.materialCode, this.formatSMTMethod(item.emptySticker, item.handSticker),
        item.isFeeding ? '<span style="background-color: green; padding: 6px">已上料</span>' : item.emptySticker || item.handSticker ? '<span style="font-size: 11px; background-color: green; padding: 6px">无需上料</span>' : '<span style="background-color: red; padding: 6px">待上料</span>',
        item.firstInspection == 1 ? '<span style="background-color: green; padding: 6px">已首检</span>' : item.emptySticker || item.handSticker ? '<span style="font-size: 11px; background-color: green; padding: 6px">无需首检</span>' : '<span style="background-color: red; padding: 6px">待首检</span>',
        item.alternativeOriginalStr ? item.alternativeOriginalStr : "-"]);
      this.config = { ...this.config };
    },
    formatSMTMethod(value1, value2) {
      if (value1){
        return '空贴';
      }else if (value2){
        return '手贴';
      }else if (!value1 && !value2){
        return '机贴';
      }else{
        return '-';
      }
    }
  }
}
</script>

<style lang="less">
.bottom-right-table-1 {
  width: 32%;
  height: 100%;
  margin: 0 -5px;

  .border-box-content {
    padding: 20px;
    box-sizing: border-box;
  }

  .table-name {
    height: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;

    img {
      width: 40px;
      height: 40px;
      margin-right: 5px;
    }
  }

  .dv-scroll-board {
    height: calc(~"100% - 60px");
  }
}
</style>
